export const accteptedFiles =
  'image/jpeg, image/png, video/mp4, video/quicktime, video/mpeg, audio/wav, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/pdf'
